// removed by extract-text-webpack-plugin
module.exports = {"yandexLogo":"_22a5-"};


//////////////////
// WEBPACK FOOTER
// ./components/icons/YandexIcon/YandexIcon.scss
// module id = 280
// module chunks = 0 1